import type { PartialFeedbackPayload } from "@asurion-core/expert-workspace-feedback";

import { useExpertAssistStore } from "../../state";

export const useFeedbackPayload = (): Omit<PartialFeedbackPayload, "caller"> => {
    const { sessionId, callSid, token, partner } = useExpertAssistStore();

    return {
        appName: "standalone-expert-assist",
        callSid,
        feedbackType: "NoTextFeedback",
        sessionId,
        partner,
        ssoAccessToken: token ?? "",
        extraData: { "Expert Assist Type": "Reactive" },
    };
};
